import * as React from 'react';

function SvgInformationStroke(props) {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.4999 1.65002C10.7308 1.65002 13.3499 4.26916 13.3499 7.50002C13.3499 10.7309 10.7308 13.35 7.4999 13.35C4.26904 13.35 1.6499 10.7309 1.6499 7.50002C1.6499 4.26916 4.26904 1.65002 7.4999 1.65002ZM7.4999 2.35002C4.65564 2.35002 2.3499 4.65576 2.3499 7.50002C2.3499 10.3443 4.65564 12.65 7.4999 12.65C10.3442 12.65 12.6499 10.3443 12.6499 7.50002C12.6499 4.65576 10.3442 2.35002 7.4999 2.35002ZM8.16657 6.08336V9.41669H8.9999V10.25H6.4999V9.41669H7.33324L7.3329 6.91636L6.4999 6.91669V6.08336H8.16657ZM7.54157 4.00002C7.88675 4.00002 8.16657 4.27985 8.16657 4.62502C8.16657 4.9702 7.88675 5.25002 7.54157 5.25002C7.19639 5.25002 6.91657 4.9702 6.91657 4.62502C6.91657 4.27985 7.19639 4.00002 7.54157 4.00002Z"
        fill="#3F4245"
      />
    </svg>
  );
}

export default SvgInformationStroke;
